function formatLocalDate(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function runDailyAutoNotifications({
    students,
    schedules,
    finances,
    annualBudget,
    addNotification
}) {
    if (!students.length && !schedules.length) {
        return;
    }

    const today = new Date();
    const todayStr = formatLocalDate(today);
    const checkedKey = `notifications_checked_${todayStr}`;

    if (localStorage.getItem(checkedKey)) {
        return;
    }
    localStorage.setItem(checkedKey, "true");

    const oneDayLater = new Date(today);
    oneDayLater.setDate(today.getDate() + 1);
    const tomorrowStr = formatLocalDate(oneDayLater);

    students.forEach((student) => {
        if (!student.birth) {
            return;
        }
        try {
            const birthStr = typeof student.birth === "string"
                ? student.birth
                : (student.birth?.toDate ? student.birth.toDate().toISOString().split("T")[0] : String(student.birth));
            const birthParts = birthStr.replace(/\./g, "-").split("-");
            if (birthParts.length < 3) {
                return;
            }

            const birthMonth = parseInt(birthParts[1], 10);
            const birthDay = parseInt(birthParts[2], 10);
            const thisYearBirth = new Date(today.getFullYear(), birthMonth - 1, birthDay);

            if (thisYearBirth.toDateString() === today.toDateString()) {
                addNotification(
                    `🎂 오늘의 주인공, ${student.name}!`,
                    `오늘은 '${student.name}'님의 특별한 날이에요. 축복의 메시지를 전해보는 건 어떨까요? 🎉`,
                    "success",
                    "birthday",
                    student.id
                );
            } else if (thisYearBirth.toDateString() === oneDayLater.toDateString()) {
                addNotification(
                    `🎂 내일은 ${student.name}님의 날`,
                    `내일 '${student.name}'님의 생일이에요. 마음을 준비해 두세요! 🎁`,
                    "info",
                    "birthday",
                    student.id
                );
            }
        } catch (e) {
            // Ignore invalid date format.
        }
    });

    schedules.forEach((schedule) => {
        if (!schedule.date) {
            return;
        }

        const scheduleDateStr = schedule.date;
        if (scheduleDateStr === todayStr) {
            addNotification(
                `📅 오늘 함께해요: ${schedule.title}`,
                `오늘 ${schedule.startTime || "예정된"} 일정이 있어요${schedule.location ? ` @ ${schedule.location}` : ""}. 힘내세요! 💪`,
                "info",
                "schedule",
                schedule.id
            );
        }

        if (scheduleDateStr === tomorrowStr) {
            addNotification(
                `📅 내일을 위한 준비: ${schedule.title}`,
                `내일 일정이 기다리고 있어요${schedule.startTime ? ` (${schedule.startTime})` : ""}${schedule.location ? ` @ ${schedule.location}` : ""}. 기대되네요!`,
                "info",
                "schedule",
                schedule.id
            );

            const hasIncomplete = (schedule.checklists || []).some((item) => !item.checked);
            if (hasIncomplete) {
                addNotification(
                    "✅ 준비물, 놓친 건 없으신가요?",
                    `'${schedule.title}' 체크리스트에 아직 완료되지 않은 항목이 있어요. 미리 체크해두면 마음이 편하죠! 📝`,
                    "warning",
                    "checklist",
                    schedule.id
                );
            }
        }
    });

    students.forEach((student) => {
        const lastContact = student.lastVisit && student.lastVisit !== "-" ? student.lastVisit : student.createdAt;
        try {
            const lastDate = new Date(lastContact);
            const daysSince = Math.floor((today - lastDate) / (1000 * 60 * 60 * 24));

            if (daysSince >= 14) {
                addNotification(
                    `💭 ${student.name}님이 보고 싶어요`,
                    `${daysSince}일째 만나지 못했어요. 짧은 안부 한 통이 큰 위로가 될 수 있어요 ❤️`,
                    "warning",
                    "pastoral",
                    student.id
                );
            }
        } catch (e) {
            // Ignore invalid date.
        }
    });

    if (!annualBudget) {
        return;
    }

    const currentYear = today.getFullYear();
    const yearlyExpense = finances
        .filter((item) => item.type === "지출" && item.date?.startsWith(String(currentYear)))
        .reduce((acc, cur) => acc + parseInt(cur.amount || 0, 10), 0);

    const budget = typeof annualBudget === "object"
        ? Object.values(annualBudget).reduce((acc, value) => acc + (Number(value) || 0), 0)
        : Number(annualBudget) || 0;

    const remaining = budget - yearlyExpense;
    const percentUsed = budget > 0 ? ((budget - remaining) / budget) * 100 : 0;

    if (percentUsed >= 80 && remaining > 0) {
        addNotification(
            "💰 예산의 마지막 구간이에요",
            `예산의 ${Math.round(percentUsed)}%를 사용했어요. 여기까지 잘 해오셨네요! 남은 ${remaining.toLocaleString()}원, 지혜롭게 마무리해봐요 ✨`,
            "warning",
            "budget",
            null
        );
    } else if (remaining < 0) {
        addNotification(
            "🚨 예산을 넘어섰어요",
            `예산을 ${Math.abs(remaining).toLocaleString()}원 초과했어요. 괜찮아요, 함께 다음 계획을 세워봐요 📊`,
            "error",
            "budget",
            null
        );
    }
}
